/**
 * Activity Feed Types
 * Matches backend DTOs from ActivityController
 */

export interface ActivityUser {
  id: number;
  username: string;
  avatarUrl: string | null;
  countryCode: string | null;
}

export interface ActivityCard {
  id: number;
  name: string;
  scryfallId: string;
  imageUrl: string; // Full CDN URL from backend - use directly
  setCode: string;
  foil: boolean;
}

export type ActivityType = 'trade_sent' | 'trade_received' | 'want_added';

export interface Activity {
  id: string; // Format: ${type}_${sourceId}_${itemIndex}
  type: ActivityType;
  createdAt: string; // ISO timestamp
  user: ActivityUser;
  card: ActivityCard;
  pointValue: number | null; // null → show "???"
}

export interface RecentActivityResponse {
  activities: Activity[];
  nextCursor: string | null;
  hasMore: boolean;
}

export interface RecentActivityRequest {
  limit?: number;
  cursor?: string;
}

/**
 * Get display text for activity type
 */
export const getActivityActionText = (type: ActivityType): string => {
  switch (type) {
    case 'trade_sent':
      return 'sent:';
    case 'trade_received':
      return 'received:';
    case 'want_added':
      return 'wants:';
    default:
      return '';
  }
};
